module.exports = __webpack_public_path__ + "static/rocket-acb50be3c69448f5f54852736f37deb1.svg";